import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import SideNav from './SideNav';
import Discription from './Discription';
import userPlaceholder from '../Assets/user.png'; // fallback image
// Optionally import a helper like axios if preferred
// import axios from 'axios';

export default function EmpLanding() {
  // State for user details and jobs list
  const [userData, setUserData] = useState({
    name: 'Employee Name',
    photo: userPlaceholder,
  });
  const [jobs, setJobs] = useState([]);
  const [currentjobIndex, setCurrentjobIndex] = useState(0);
  const [currentCampIndex, setCurrentCampIndex] = useState(0);
  const [isSideNavOpen, setIsSideNavOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const [isJobDropdownOpen, setIsJobDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [selectedJob, setSelectedJob] = useState(null);

  // Fetch user details from the employee dashboard API
  useEffect(() => {
    async function fetchUserData() {
      try {
        const response = await fetch('https://api.example.com/employee/details');
        const data = await response.json();
        // Assume response contains { name, photo }
        setUserData({
          name: data.name,
          photo: data.photo || userPlaceholder,
        });
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    }
    fetchUserData();
  }, []);

  // Fetch jobs listing from the employer API
  useEffect(() => {
    async function fetchJobs() {
      try {
        const response = await fetch('https://api.example.com/employer/jobs');
        const data = await response.json();
        // Assume data is an array of job objects
        setJobs(data);
      } catch (error) {
        console.error('Error fetching jobs:', error);
      }
    }
    fetchJobs();
  }, []);

  // Event handler for job card click – opens detail modal
  const handleCardClick = (job) => {
    setSelectedJob(job);
  };

  const handleClose = () => {
    setSelectedJob(null);
  };

  const toggleSideNav = () => {
    setIsSideNavOpen(!isSideNavOpen);
  };

  const handleNavigation = (category, option) => {
    console.log(`Navigating to: ${category} - ${option}`);
    setIsServicesDropdownOpen(false);
    setIsJobDropdownOpen(false);
    // Navigate or update state as needed
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsServicesDropdownOpen(false);
        setIsJobDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Handlers for the carousel navigations
  const handlePrevJobs = () => {
    setCurrentjobIndex((prevIndex) => (prevIndex === 0 ? jobs.length - 1 : prevIndex - 1));
  };

  const handleNextJobs = () => {
    setCurrentjobIndex((prevIndex) => (prevIndex === jobs.length - 1 ? 0 : prevIndex + 1));
  };

  const handlePrevCamp = () => {
    setCurrentCampIndex((prevIndex) => (prevIndex === 0 ? jobs.length - 1 : prevIndex - 1));
  };

  const handleNextCamp = () => {
    setCurrentCampIndex((prevIndex) => (prevIndex === jobs.length - 1 ? 0 : prevIndex + 1));
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F4F1E9', color: '#2B2B2B' }}>
      {/* Header Section */}
      <div
        className="shadow-md sm:pr-28 py-4 flex items-center gap-4 sm:gap-20 justify-start sm:justify-between px-6"
        style={{ backgroundColor: '#fff' /* or a lighter tone from the palette */ }}
      >
        <div className="flex items-center space-x-4">
          <button
            onClick={toggleSideNav}
            className="p-2 rounded-full hover:bg-gray-200"
          >
            <i className="ri-menu-3-line text-2xl" style={{ color: '#2B2B2B' }}></i>
          </button>
          <img
            src={userData.photo}
            alt="User Avatar"
            className="w-10 h-10 rounded-full"
          />
        </div>
        <div className="flex space-x-6">
          <div
            className="relative"
            onMouseEnter={() => setIsJobDropdownOpen(true)}
            onMouseLeave={() => setIsJobDropdownOpen(false)}
          >
            <button className="hover:underline" style={{ color: '#2B2B2B' }}>
              <b>JOBS</b> <i className="ri-arrow-down-s-line"></i>
            </button>
            {isJobDropdownOpen && (
              <div className="absolute mt-0 bg-white shadow-lg rounded p-2 w-48">
                {['Search Jobs', 'Saved Jobs'].map((item) => (
                  <div key={item} className="p-2 hover:bg-gray-100" onClick={() => handleNavigation('Jobs', item)}>
                    {item}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div
            className="relative"
            onMouseEnter={() => setIsServicesDropdownOpen(true)}
            onMouseLeave={() => setIsServicesDropdownOpen(false)}
          >
            <button className="hover:underline" style={{ color: '#2B2B2B' }}>
              <b>SERVICES</b> <i className="ri-arrow-down-s-line"></i>
            </button>
            {isServicesDropdownOpen && (
              <div className="absolute mt-0 bg-white shadow-lg rounded p-2 md:w-48 w-[9rem]">
                {['Resume Writing', 'Find Jobs'].map((item) => (
                  <div key={item} className="p-2 hover:bg-gray-100" onClick={() => handleNavigation('Services', item)}>
                    {item}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="flex space-x-6">
            <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                `hover:underline ${isActive ? 'font-bold' : ''}`
              }
              style={{ color: '#2B2B2B' }}
            >
              <b>Dashboard</b>
            </NavLink>
          </div>
        </div>
      </div>
      <SideNav isOpen={isSideNavOpen} onClose={toggleSideNav} />

      {/* Main Section */}
      <div className="p-6 space-y-8">
        {/* Profile Sidebar */}
        <div className="flex md:space-x-6 space-y-6 flex-col md:flex-row">
          <div
            className="shadow rounded-lg p-6 w-full md:w-1/3 xl:w-1/4"
            style={{ backgroundColor: '#fff' }}
          >
            <img
              src={userData.photo}
              alt={userData.name}
              className="w-24 h-24 mx-auto rounded-full mb-4"
            />
            <p className="text-center font-semibold text-lg mb-4">{userData.name}</p>
            <ul className="space-y-3">
              <NavLink
                to="/Elanding"
                className={({ isActive }) =>
                  `flex items-center space-x-2 rounded-lg px-3 py-2 ${isActive ? 'bg-gray-300' : 'hover:bg-gray-200'}`
                }
              >
                <i className="ri-home-fill"></i>
                <span>My Home</span>
              </NavLink>
              <NavLink
                to="/apply"
                className={({ isActive }) =>
                  `flex items-center space-x-2 rounded-lg px-3 py-2 ${isActive ? 'bg-gray-300' : 'hover:bg-gray-200'}`
                }
              >
                <i className="ri-briefcase-fill"></i>
                <span>Jobs</span>
              </NavLink>
              <NavLink
                to="/company"
                className={({ isActive }) =>
                  `flex items-center space-x-2 rounded-lg px-3 py-2 ${isActive ? 'bg-gray-300' : 'hover:bg-gray-200'}`
                }
              >
                <i className="ri-building-fill"></i>
                <span>Companies</span>
              </NavLink>
            </ul>
            <hr className="my-4" />
            <p className="text-center text-gray-500">How Jobgenee Works?</p>
          </div>

          {/* Jobs and Companies Section */}
          <div className="flex-1 space-y-6 md:w-1/2">
            {/* Recommended Jobs Carousel */}
            <div className="shadow rounded-lg p-6" style={{ backgroundColor: '#fff' }}>
              <h2 className="text-xl font-semibold mb-4">Recommended Jobs</h2>
              <div className="relative">
                <div
                  className="absolute left-0 top-1/2 -translate-y-1/2 p-2 rounded-full cursor-pointer hover:bg-gray-300 z-50"
                  onClick={handlePrevJobs}
                  style={{ backgroundColor: '#D66A20' }}  // Primary color
                >
                  <i className="ri-arrow-left-s-line text-xl"></i>
                </div>
                <div className="flex overflow-hidden">
                  <div
                    className="flex transition-transform duration-300"
                    style={{ transform: `translateX(-${currentjobIndex * 250}px)` }}
                  >
                    {jobs.map((job, index) => (
                      <div
                        key={index}
                        className="w-60 p-4 rounded-lg shadow mx-2 text-center cursor-pointer"
                        style={{ backgroundColor: '#F4F1E9' }}  // Background tone
                        onClick={() => handleCardClick(job)}
                      >
                        <p className="text-lg font-semibold">
                          {job.logo ? <img src={job.logo} alt={`${job.company} logo`} className="w-12 h-12 mx-auto" /> : 'Logo'}
                        </p>
                        <p>{job.title}</p>
                        <p>{job.company}</p>
                        <p className="text-gray-500">
                          <i className="ri-map-pin-line"></i> {job.location}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
                <div
                  className="absolute right-0 top-1/2 -translate-y-1/2 p-2 rounded-full cursor-pointer hover:bg-gray-300"
                  onClick={handleNextJobs}
                  style={{ backgroundColor: '#D66A20' }}  // Primary color
                >
                  <i className="ri-arrow-right-s-line text-xl"></i>
                </div>
              </div>
            </div>

            {/* Top Companies Carousel */}
            <div className="shadow rounded-lg p-6" style={{ backgroundColor: '#fff' }}>
              <h2 className="text-xl font-semibold mb-4">Top Companies</h2>
              <div className="relative">
                <div
                  className="absolute left-0 top-1/2 -translate-y-1/2 p-2 rounded-full cursor-pointer hover:bg-gray-300 z-50"
                  onClick={handlePrevCamp}
                  style={{ backgroundColor: '#D66A20' }}
                >
                  <i className="ri-arrow-left-s-line text-xl"></i>
                </div>
                <div className="flex overflow-hidden">
                  <div
                    className="flex transition-transform duration-300"
                    style={{ transform: `translateX(-${currentCampIndex * 250}px)` }}
                  >
                    {jobs.map((company, index) => (
                      <div
                        key={index}
                        className="w-60 p-4 rounded-lg shadow mx-2 text-center cursor-pointer"
                        style={{ backgroundColor: '#F4F1E9' }}
                      >
                        <p className="text-lg font-semibold">
                          {company.logo ? <img src={company.logo} alt={`${company.company} logo`} className="w-12 h-12 mx-auto" /> : 'Logo'}
                        </p>
                        <p>{company.company}</p>
                        <p className="text-gray-500">
                          <i className="ri-map-pin-line"></i> {company.location}
                        </p>
                        <div className="hover:underline" style={{ color: '#014D4E' /* Secondary color */ }}>
                          <NavLink to="/company">View Jobs</NavLink>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div
                  className="absolute right-0 top-1/2 -translate-y-1/2 p-2 rounded-full cursor-pointer hover:bg-gray-300"
                  onClick={handleNextCamp}
                  style={{ backgroundColor: '#D66A20' }}
                >
                  <i className="ri-arrow-right-s-line text-xl"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {selectedJob && <Discription job={selectedJob} onClose={handleClose} />}
    </div>
  );
}
